module.exports = __webpack_public_path__ + "static/media/all-hawkes-logos-new-hawkes-logo-eddie-white-copy-2@3x.a823c785.png";